export const getMarkerIcon = () => ({
  url:
    'data:image/svg+xml;charset=UTF-8,' +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg"
           width="36"
           height="36"
           viewBox="0 0 24 24">

        <path
          fill="#6D28D9"
          d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>

        <circle
          cx="12"
          cy="9"
          r="2.5"
          fill="#9CA3AF"/>

      </svg>
    `),
  scaledSize: new window.google.maps.Size(36, 36),
});
